import React, { useEffect } from "react";

const BUTTON_BY_THEME = {
  MKH: "bg-[#29a6d6] hover:bg-[#1e7ba6]",
  SJ: "bg-green-700 hover:bg-green-800",
};

/**
 * Shown before a question when its mode (or the question itself) has an
 * intro: explains how to play with text and/or an image. For draw questions
 * it also shows the session QR, and moves on by itself once the drawer has
 * scanned it.
 */
const QuestionIntro = ({ intro, title, theme, drawHost, onContinue }) => {
  const showQr = !!drawHost && drawHost.phase !== "error";

  useEffect(() => {
    if (drawHost?.phase === "drawing") onContinue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawHost?.phase]);

  const hasVisual = !!intro.image || showQr;

  return (
    <div className="w-full h-[90vh] p-4 md:p-8">
      <div
        dir="rtl"
        className="h-full w-full bg-white rounded-3xl shadow-lg flex flex-col gap-4 p-4 md:p-8"
      >
        {title && (
          <h2 className="text-center text-2xl md:text-4xl font-bold text-gray-900">
            {title}
          </h2>
        )}

        <div className="flex-1 min-h-0 flex flex-col md:flex-row gap-4 md:gap-8">
          {(intro.text || !hasVisual) && (
            <div className="flex-1 min-h-0 overflow-y-auto flex">
              <p className="m-auto text-center text-xl md:text-3xl font-bold leading-relaxed text-gray-800 whitespace-pre-line">
                {intro.text}
              </p>
            </div>
          )}

          {hasVisual && (
            <div className="flex-1 min-h-0 flex flex-col sm:flex-row items-center justify-center gap-4">
              {intro.image && (
                <img
                  className="min-h-0 min-w-0 max-h-full flex-1 object-contain rounded-xl"
                  src={intro.image}
                  alt={title || ""}
                />
              )}
              {showQr && (
                <div className="min-h-0 max-h-full flex flex-col items-center gap-2">
                  {drawHost.qrDataUrl ? (
                    <img
                      className="min-h-0 w-48 md:w-72 object-contain rounded-xl border border-gray-200"
                      src={drawHost.qrDataUrl}
                      alt="QR"
                    />
                  ) : (
                    <div className="w-48 h-48 md:w-72 md:h-72 rounded-xl bg-gray-100 animate-pulse" />
                  )}
                  <p className="text-lg md:text-2xl font-bold text-gray-900">
                    {drawHost.qrDataUrl
                      ? "امسح الرمز وابدأ الرسم"
                      : "جاري التحميل..."}
                  </p>
                </div>
              )}
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={onContinue}
          className={`self-center text-white font-bold py-3 px-10 rounded-md text-lg md:text-2xl ${
            BUTTON_BY_THEME[theme] || "bg-mainButton hover:bg-mainButtonShadow"
          }`}
        >
          {showQr ? "متابعة" : "ابدأ"}
        </button>
      </div>
    </div>
  );
};

export default QuestionIntro;
